import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { labelText } from "@cloudpivot/form/src/schema/system-data-item-codes";
import HLabel from "@cloudpivot/form/src/common/components/label.vue";
let CreateTime = class CreateTime extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], CreateTime.prototype, "control", void 0);
CreateTime = tslib_1.__decorate([
    Component({
        name: 'CreateTime',
        components: {
            HLabel: HLabel
        }
    })
], CreateTime);
export default CreateTime;
